import OfferBanner from './OfferBanner';

export default OfferBanner;
